import { toast } from 'react-toastify'

export function toastError (message: string) {
  const shouldSuppress = !document.location.pathname.startsWith('/admin')
      || message.includes('CanceledError')
      || message.includes('Network Error')

  if (shouldSuppress) {
    console.error(`Suppressed error toast: ${message}`)
    return -1
  } else {
    return toast.error(message, { autoClose: 3500 })
  }
}

export function toastSuccess (message: string) {
  return toast.success(message, { autoClose: 2500 })
}

export function toastWarning (message: string) {
  return toast.warn(message, { autoClose: 2500 })
}
